import InnerCircleText, {InnerCircleTextProps} from './InnerCircleText';

export type {InnerCircleTextProps};
export default InnerCircleText;
